import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full flex flex-wrap rounded-lg bg-gray-100 p-6 sm:p-10" }
const _hoisted_2 = { class: "w-full mb-6" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pb-0" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "w-full mb-4 bg-white rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_6 = { class: "flex items-center gap-2 font-semibold text-gray-700" }
const _hoisted_7 = { class: "border-t border-gray-100 px-1 pb-3" }
const _hoisted_8 = { class: "w-full flex flex-wrap" }
const _hoisted_9 = { class: "w-full flex flex-wrap items-center justify-end gap-2 px-3 pt-2 border-t border-gray-100 mt-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 1,
  class: "w-full flex flex-wrap items-center justify-between gap-2 mt-4"
}
const _hoisted_16 = { class: "text-sm text-gray-600" }
const _hoisted_17 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_18 = { class: "text-sm text-gray-600 whitespace-nowrap" }
const _hoisted_19 = { class: "w-full flex flex-wrap" }
const _hoisted_20 = {
  key: 3,
  class: "w-full px-3"
}
const _hoisted_21 = { class: "w-full flex justify-between items-center sticky bottom-0 z-10 bg-white border-t border-gray-200 pt-3 pb-1 mt-2" }
const _hoisted_22 = { class: "w-full flex flex-col gap-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { class: "flex items-center justify-between w-full" }
const _hoisted_27 = { class: "w-full py-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 dark:text-gray-200 mb-4 text-base" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Informe ao(a) motorista:"),
  /*#__PURE__*/_createTextVNode(" Ao chegar na empresa, deve se apresentar e informar o código do agendamento abaixo. ")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-300 mb-2" }, "Código do Agendamento", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "bg-yellow-50 border border-yellow-200 rounded-lg p-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-yellow-800" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Importante:"),
    /*#__PURE__*/_createTextVNode(" Guarde este código e compartilhe com o(a) motorista. Este código será necessário para a identificação na portaria. ")
  ])
], -1)
const _hoisted_31 = { class: "w-full flex justify-center pb-2" }

import InformacoesMotorista from "@/components/agendamento/InformacoesMotorista.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import { itensOperacao, operacaoDisponivel } from "@/components/agendamento/operacoes";
import HorariosDisponiveis from "@/components/agendamento/HorariosDisponiveis.vue";
import Badge from "@/components/Badge.vue";
import FormValidated from "@/components/FormValidated.vue";
import InputArray from "@/components/inputs/InputArray.vue";
import InputText from "@/components/inputs/InputText.vue";
import SelectInput from "@/components/inputs/SelectInput.vue";
import ListHeader from "@/components/ListHeader.vue";
import helpers from "@/helpers";
import store from "@/store";
import { getThemeColor } from "@/branding";
import { computed, onMounted, ref } from "vue";
import { InitialData } from "./AgendamentoAgendar.vue";
import DialogModal from "@/components/Modal/DialogModal.vue";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";

interface IFiltros {
  data: string;
  setor_ukey: string;
  periodo: string;
  tipo_carga: string;
  a29_ukey: string;
  operacao: number;
  page?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AgendamentoMeus',
  setup(__props) {

const theme = getThemeColor();

const meus_agendamentos = computed(() => store.state.meus_agendamentos);

const usuario_externo = computed(() => store.state.acessos.usuario_externo);

const array_tipo_veiculo = computed(() => store.state.arr["array_tipo_veiculo"]?.valores);

const array_setor = computed(() => store.state.arr["array_setor"]?.valores);

const setorUsaJanelas = (setorUkey: unknown) =>
  !!store.state.setores_usa_janelas[String(setorUkey ?? "")];

const modalProdutos = ref<InitialData | null>(null);
const route = useRoute();
const router = useRouter();
const showModalCodigo = ref(false);
const codigoAgendamento = ref<string>("");

const novoFiltro = () => {
  return {
    data: "",
    setor_ukey: "",
    periodo: "",
    tipo_carga: "",
    a29_ukey: "",
    operacao: 0,
  };
};

const initialValuesFiltros = computed(() => store.state.meus_agendamentos_filtros);

const ddis = computed(() => store.state?.ddis ?? []);

const showFiltros = ref(false);
const filtrosAbertos = ref(false);

const limparFiltros = async () => {
  await search(novoFiltro());
};

// Submeter o formulário de filtros sempre volta para a primeira página.
const filtrar = async (values: IFiltros) => {
  await search({ ...values, page: 1 });
};

const paginacao = computed(() => store.state.meus_agendamentos_paginacao);

const irParaPagina = async (pagina: number) => {
  if (pagina < 1 || pagina > paginacao.value.last_page) {
    return;
  }

  await search({ ...(initialValuesFiltros.value ?? novoFiltro()), page: pagina });
};
onMounted(async () => {
  await store.dispatch("getSetores");
  await store.dispatch("getVeiculos");
  await store.dispatch("buscaDdis");

  if (typeof initialValuesFiltros.value?.data == "undefined") {
    await search(novoFiltro());
  } else {
    await search(initialValuesFiltros.value);
  }

  const codigo = route.query.codigo as string;
  if (codigo) {
    codigoAgendamento.value = codigo;
    showModalCodigo.value = true;
    router.replace({ query: {} });
  }
});

const fecharModalCodigo = () => {
  showModalCodigo.value = false;
  codigoAgendamento.value = "";
};

const search = async (filtros: IFiltros | null) => {
  console.log(filtros);

  showFiltros.value = false;
  await store.dispatch("getMeusAgendamentos", filtros);
  showFiltros.value = true;
};

const showFormEditar = ref(false);
const initialValuesEditar = ref(null);

// Editável enquanto a TAG (n06) e a tarefa (n02) do agrupamento (N01) não
// existirem e a data agendada for hoje ou futura.
const podeEditar = (item: any) =>
  item.cancelado == 0 &&
  !item.agrupamento?.n06_ukey &&
  !item.agrupamento?.n02_ukey &&
  String(item.data ?? "").substring(0, 10) >= helpers.getDataAtual();

const onClickEditar = (val: any) => {
  if (val?.agrupamento?.n06_ukey || val?.agrupamento?.n02_ukey) {
    helpers.mensagemErro(
      "Agendamento já está em processamento, não é possível editar."
    );
    return;
  }

  initialValuesEditar.value = val;
  showFormEditar.value = true;
};

// Mesma lógica do agendar: obrigatórios conforme o setor, todos marcados de uma vez.
const validacaoExtraEditar = (values: any) => {
  const erros: Record<string, string> = {};
  const usaJanelas = setorUsaJanelas(values.setor_ukey);

  if (usaJanelas && !values.horario) {
    erros.horario = "Selecione um horário disponível.";
  }

  if (!usaJanelas && !values.periodo) {
    erros.periodo = "Campo Obrigatório";
  }

  if (!usaJanelas && !values.previsao_horario_chegada) {
    erros.previsao_horario_chegada = "Campo Obrigatório";
  }

  if (
    values.operacao &&
    !operacaoDisponivel(values.setor_ukey, Number(values.operacao) as 1 | 2)
  ) {
    erros.operacao = "Este setor não possui horários para a operação selecionada.";
  }

  if (!values.operacao) {
    erros.operacao = "Campo Obrigatório";
  }

  return erros;
};

const onSubmitEditar = async (values: any) => {
  const retorno = await store.dispatch("enviarAgendamento", values);

  if (!retorno?.success) {
    return;
  }

  initialValuesEditar.value = null;
  showFormEditar.value = false;

  await search(null);
};

const onClickDelete = async (item: any) => {
  if (item?.agrupamento?.n06_ukey) {
    helpers.mensagemErro("Não é possível apagar agendamento com TAG já vinculado.");
    return;
  }

  if (!window.confirm("Realmente deseja apagar este agendamento?")) {
    return;
  }

  await store.dispatch("apagarAgendamento", item.ukey);
  await search(null);
};

const verDocumento = async (documento: string) => {
  const { data } = await axios.post(`/helpers/minio/get-image-url`, {
    nome: documento,
  });

  helpers.openUrl(data);
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_t_button = _resolveComponent("t-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_t_table = _resolveComponent("t-table")!
  const _component_t_dialog_modal = _resolveComponent("t-dialog-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", {
            class: _normalizeClass(["text-2xl sm:text-3xl font-bold", `text-${_unref(theme)}-900`])
          }, " Últimos Agendamentos ", 2)
        ]),
        _createVNode(_component_router_link, {
          to: {
            name: 'AgendamentoAgendar',
          },
          class: "flex-shrink-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_t_button, {
              class: _normalizeClass(["text-white font-semibold px-6 py-2.5 shadow-md hover:shadow-lg transition-all duration-200", `bg-${_unref(theme)}-800 hover:bg-${_unref(theme)}-900`])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "plus",
                  class: "mr-2"
                }),
                _createTextVNode(" Novo Agendamento ")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        type: "button",
        class: "w-full flex items-center justify-between px-4 py-3 focus:outline-none",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (filtrosAbertos.value = !filtrosAbertos.value))
      }, [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_font_awesome_icon, {
            icon: "filter",
            class: _normalizeClass(`text-${_unref(theme)}-800`)
          }, null, 8, ["class"]),
          _createTextVNode(" Filtros ")
        ]),
        _createVNode(_component_font_awesome_icon, {
          icon: "chevron-down",
          class: _normalizeClass(["text-gray-400 transform transition-transform duration-200", filtrosAbertos.value ? 'rotate-180' : ''])
        }, null, 8, ["class"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        (showFiltros.value)
          ? (_openBlock(), _createBlock(FormValidated, {
              key: 0,
              "initial-values": _unref(initialValuesFiltros),
              "hide-buttons": true,
              onSave: filtrar
            }, {
              form: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(SelectInput, {
                    name: "setor_ukey",
                    tclass: "md:w-1/2",
                    label: "Setor",
                    items: _unref(array_setor)
                  }, null, 8, ["items"]),
                  _createVNode(SelectInput, {
                    name: "periodo",
                    label: "Período",
                    tclass: "md:w-1/2",
                    items: [
                { name: 'Selecione...', value: '' },
                { name: 'Manhã', value: 1 },
                { name: 'Tarde', value: 2 },
                { name: 'Noite', value: 3 },
              ]
                  }, null, 8, ["items"]),
                  _createVNode(InputArray, {
                    name: "tipo_carga",
                    tclass: "md:w-1/2",
                    label: "Carga",
                    arrayName: "tipo_carga",
                    excludeItem: 1
                  }),
                  _createVNode(SelectInput, {
                    name: "a29_ukey",
                    tclass: "md:w-1/2",
                    label: "Veículo",
                    items: _unref(array_tipo_veiculo)
                  }, null, 8, ["items"]),
                  _createVNode(InputText, {
                    type: "date",
                    name: "data",
                    tclass: "md:w-1/2",
                    label: "Data Agendamento"
                  }),
                  _createVNode(SelectInput, {
                    name: "operacao",
                    label: "Operação",
                    tclass: "md:w-1/2",
                    items: [
                { name: 'Selecione...', value: 0 },
                { name: 'Carregar', value: 1 },
                { name: 'Descarregar', value: 2 },
              ]
                  }, null, 8, ["items"]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_t_button, {
                      type: "button",
                      color: "gray",
                      class: "mt-0 mr-0",
                      onClick: limparFiltros
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "eraser",
                          class: "mr-2"
                        }),
                        _createTextVNode("Limpar ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_t_button, {
                      type: "submit",
                      class: _normalizeClass(["mt-0 mr-0 text-white font-semibold", `bg-${_unref(theme)}-800 hover:bg-${_unref(theme)}-900`])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "filter",
                          class: "mr-2"
                        }),
                        _createTextVNode("Filtrar ")
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["initial-values"]))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, filtrosAbertos.value]
      ])
    ]),
    (_unref(meus_agendamentos))
      ? (_openBlock(), _createBlock(_component_t_table, {
          key: 0,
          actions: true,
          value: _unref(meus_agendamentos),
          header: {
        data: 'Data Agendada',
        agrupamento: 'Código do Agendamento',
        setor: 'Setor',
        tipo_veiculo: 'Tipo veículo',
        motorista: 'Motorista',
        periodo_nome: 'Horário/Período',
        operacao: 'Operação',
        status: 'Status',
        actions: 'Ações',
      }
        }, {
          operacao: _withCtx(({ $item: item }) => [
            _createTextVNode(_toDisplayString(item?.operacao == 1 ? "Carregar" : "") + " " + _toDisplayString(item?.operacao == 2 ? "Descarregar" : "") + " ", 1),
            (item.produtos.length > 0)
              ? (_openBlock(), _createBlock(_component_t_button, {
                  key: 0,
                  onClick: ($event: any) => (modalProdutos.value = item),
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ver produtos ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          agrupamento: _withCtx(({ $item: item }) => [
            _createTextVNode(_toDisplayString(item?.agrupamento?.numero), 1)
          ]),
          setor: _withCtx(({ $item: item }) => [
            _createTextVNode(_toDisplayString(item?.setor?.nome), 1)
          ]),
          tipo_veiculo: _withCtx(({ $item: item }) => [
            _createTextVNode(_toDisplayString(item?.tipo_veiculo?.codigo), 1)
          ]),
          data: _withCtx(({ $item: item }) => [
            _createTextVNode(_toDisplayString(_unref(helpers).formatData(item.data)) + " ", 1),
            _hoisted_10,
            _createVNode(Badge, { color: "gray" }, {
              default: _withCtx(() => [
                _createTextVNode(" Feito em " + _toDisplayString(_unref(helpers).formatDataWithTimezone(item.created_at)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          motorista: _withCtx(({ $item: item }) => [
            _createTextVNode(_toDisplayString(item?.parceiroMotorista ? item.parceiroMotorista?.razao_social : item.motorista), 1)
          ]),
          periodo_nome: _withCtx(({ $item: item }) => [
            (item?.horario)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.horario), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item?.periodo_nome), 1))
          ]),
          status: _withCtx(({ $item: item }) => [
            (item.cancelado == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (item.autorizado == 0)
                    ? (_openBlock(), _createBlock(Badge, {
                        key: 0,
                        color: "yellow"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Pendente de aprovação")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (item.autorizado == 1)
                    ? (_openBlock(), _createBlock(Badge, {
                        key: 1,
                        color: "green"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Aprovado")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (item.autorizado == 2)
                    ? (_openBlock(), _createBlock(Badge, {
                        key: 2,
                        color: "red"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Reprovado")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(Badge, { color: "red" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancelado ")
                    ]),
                    _: 1
                  })
                ]))
          ]),
          actions: _withCtx(({ $item: item }) => [
            (podeEditar(item))
              ? (_openBlock(), _createBlock(_component_t_button, {
                  key: 0,
                  class: "w-full",
                  onClick: ($event: any) => (onClickEditar(item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "pen",
                      class: "mr-1"
                    }),
                    _createTextVNode("Editar ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item.cancelado == 0 && !item.agrupamento?.n06_ukey)
              ? (_openBlock(), _createBlock(_component_t_button, {
                  key: 1,
                  onClick: ($event: any) => (onClickDelete(item)),
                  color: "red",
                  class: "whitespace-nowrap w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "trash",
                      class: "mr-1"
                    }),
                    _createTextVNode("Cancelar ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true),
    (_unref(paginacao).total > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(paginacao).total) + " agendamento" + _toDisplayString(_unref(paginacao).total == 1 ? "" : "s"), 1),
          (_unref(paginacao).last_page > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_t_button, {
                  color: "gray",
                  class: "mt-0 disabled:opacity-50 disabled:cursor-not-allowed",
                  disabled: _unref(paginacao).current_page <= 1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (irParaPagina(_unref(paginacao).current_page - 1)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "chevron-left",
                      class: "mr-1"
                    }),
                    _createTextVNode("Anterior ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createElementVNode("span", _hoisted_18, " Página " + _toDisplayString(_unref(paginacao).current_page) + " de " + _toDisplayString(_unref(paginacao).last_page), 1),
                _createVNode(_component_t_button, {
                  color: "gray",
                  class: "mt-0 mr-0 disabled:opacity-50 disabled:cursor-not-allowed",
                  disabled: _unref(paginacao).current_page >= _unref(paginacao).last_page,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (irParaPagina(_unref(paginacao).current_page + 1)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Próxima"),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "chevron-right",
                      class: "ml-1"
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_t_dialog_modal, { show: showFormEditar.value }, {
      default: _withCtx(() => [
        _createVNode(ListHeader, {
          label: "Editar Agendamento",
          class: "w-full"
        }),
        (!!initialValuesEditar.value)
          ? (_openBlock(), _createBlock(FormValidated, {
              key: 0,
              "initial-values": initialValuesEditar.value,
              "hide-buttons": true,
              onSave: onSubmitEditar,
              "validacao-extra": validacaoExtraEditar
            }, {
              form: _withCtx(({ values }) => [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(SelectInput, {
                    name: "setor_ukey",
                    tclass: "md:w-1/2",
                    label: "Setor",
                    items: _unref(array_setor)
                  }, null, 8, ["items"]),
                  _createVNode(RadioGroup, {
                    name: "operacao",
                    label: "Operação",
                    tclass: "md:w-1/2",
                    items: _unref(itensOperacao)(values.setor_ukey)
                  }, null, 8, ["items"]),
                  _createVNode(InputArray, {
                    name: "tipo_carga",
                    tclass: "md:w-1/2",
                    label: "Carga",
                    arrayName: "tipo_carga",
                    excludeItem: 1
                  }),
                  _createVNode(SelectInput, {
                    name: "a29_ukey",
                    tclass: "md:w-1/2",
                    label: "Veículo",
                    items: _unref(array_tipo_veiculo)
                  }, null, 8, ["items"]),
                  _createVNode(InputText, {
                    name: "placa",
                    tclass: "md:w-1/2",
                    label: "Placa",
                    maxlength: "7",
                    placeholder: "AAA-9A99"
                  }),
                  _createVNode(InformacoesMotorista, { tclass: "md:w-1/2" }),
                  (values.ddi)
                    ? (_openBlock(), _createBlock(SelectInput, {
                        key: 0,
                        items: _unref(ddis),
                        name: "ddi",
                        tclass: "md:w-1/2",
                        label: "País do Celular (DDI)"
                      }, null, 8, ["items"]))
                    : _createCommentVNode("", true),
                  _createVNode(InputText, {
                    label: `Celular ${values.ddi ? `+${_unref(ddis).find((i) => i.value == values.ddi)?.ddi} ${values.celular}` : ''}`,
                    name: "celular",
                    mascara: values.ddi ? '000000000000' : '(00) 00000-0000',
                    tclass: "md:w-1/2",
                    placeholder: "(99) 99999-9999"
                  }, null, 8, ["label", "mascara"]),
                  _createVNode(InputText, {
                    type: "date",
                    name: "data",
                    tclass: "md:w-1/2",
                    label: "Data Agendamento"
                  }),
                  (!setorUsaJanelas(values.setor_ukey))
                    ? (_openBlock(), _createBlock(SelectInput, {
                        key: 1,
                        name: "periodo",
                        label: "Período",
                        tclass: "md:w-1/2",
                        items: [
                { name: 'Manhã', value: 1 },
                { name: 'Tarde', value: 2 },
                { name: 'Noite', value: 3 },
              ]
                      }))
                    : _createCommentVNode("", true),
                  (!setorUsaJanelas(values.setor_ukey))
                    ? (_openBlock(), _createBlock(InputText, {
                        key: 2,
                        label: "Previsão horário de chegada",
                        name: "previsao_horario_chegada",
                        tclass: "md:w-1/2",
                        type: "time"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(InputText, {
                    label: "Peso bruto (kg)",
                    name: "peso_bruto",
                    tclass: "md:w-1/2",
                    type: "number"
                  }),
                  _createVNode(InputText, {
                    type: "textarea",
                    rows: 3,
                    maxlength: "240",
                    name: "observacoes",
                    tclass: "w-full",
                    label: "Observações"
                  }),
                  (setorUsaJanelas(values.setor_ukey))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(HorariosDisponiveis, {
                          setorField: "setor_ukey",
                          ignorarUkey: String(values.ukey ?? '')
                        }, null, 8, ["ignorarUkey"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_t_button, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ((showFormEditar.value = false), (initialValuesEditar.value = null))),
                    color: "gray",
                    class: "mt-0"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Fechar")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_t_button, {
                    type: "submit",
                    class: "mt-0"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Salvar")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["initial-values"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(DialogModal, {
      show: !!modalProdutos.value,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (modalProdutos.value = null))
    }, {
      title: _withCtx(() => [
        _createVNode(ListHeader, { label: "Produtos do agendamento" }, {
          default: _withCtx(() => [
            _createVNode(_component_t_button, {
              color: "gray",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (modalProdutos.value = null)),
              class: "mt-0"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Voltar")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        (modalProdutos.value)
          ? (_openBlock(), _createBlock(FormValidated, {
              key: 0,
              "initial-values": modalProdutos.value,
              "hide-buttons": true
            }, {
              form: _withCtx(({ values }) => [
                _createElementVNode("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values.produtos, (produto) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${produto.nome}${produto.data_validade}`,
                      class: "p-2 border rounded bg-gray-100 relative"
                    }, [
                      _createElementVNode("b", null, _toDisplayString(produto.nome), 1),
                      _createTextVNode(),
                      _hoisted_23,
                      _createElementVNode("small", null, "Validade: " + _toDisplayString(_unref(helpers).formatData(produto.data_validade)) + " - Lote: " + _toDisplayString(produto.lote), 1),
                      _hoisted_24,
                      _createElementVNode("small", null, "Quantidade: " + _toDisplayString(_unref(helpers).formatValor(produto.quantidade)), 1),
                      _hoisted_25,
                      _createVNode(_component_t_button, {
                        onClick: ($event: any) => (verDocumento(produto.laudo)),
                        size: "sm"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Laudo em PDF ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["initial-values"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(DialogModal, {
      show: showModalCodigo.value,
      onClose: fecharModalCodigo
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("h2", {
            class: _normalizeClass(["text-xl font-bold", `text-${_unref(theme)}-900`])
          }, " Agendamento Realizado com Sucesso! ", 2)
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", {
            class: _normalizeClass(["bg-gray-50 dark:bg-gray-700 border-2 dark:border-gray-600 rounded-lg p-6 mb-4", `border-${_unref(theme)}-200`])
          }, [
            _hoisted_28,
            _createElementVNode("div", {
              class: _normalizeClass(["bg-white dark:bg-gray-800 border-2 rounded-lg p-4 text-center", `border-${_unref(theme)}-800`])
            }, [
              _hoisted_29,
              _createElementVNode("p", {
                class: _normalizeClass(["text-4xl font-bold tracking-wider", `text-${_unref(theme)}-900`])
              }, _toDisplayString(codigoAgendamento.value), 3)
            ], 2)
          ], 2),
          _hoisted_30
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_t_button, {
            onClick: fecharModalCodigo,
            class: _normalizeClass(["py-3 px-10 mt-0 text-white", `bg-${_unref(theme)}-800 hover:bg-${_unref(theme)}-900`])
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Entendi ")
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})